/**
 * @type {import("vue").ComponentOptions}
 * @description 基础拖拽组件
 */
export const baseMixin = {
  props: {
    data: { default: () => ({}), type: Object },
    columns: { default: () => ({}), type: Array },
    timeFormats: { default: () => ({}), type: Array }
  }
};
export const TYPE_ENUM = {
  number: "R",
  time: 'D',
  str: 'F',
  field: 'T'
};
export const itemList = [
  {
    id: TYPE_ENUM.number,
    cnName: "自动计数",
    component: () => import("./number.vue"),
    raw: {
      serialNoRule: {
        length: 4,
        overFlowRule: 0,
        resetRule: 0,
        startValue: 1
      }
    }
  },
  {
    id: TYPE_ENUM.time,
    cnName: "创建时间",
    component: () => import("./time.vue"),
    raw: {
      contentFormat: ""
    }
  },
  {
    id: TYPE_ENUM.str,
    cnName: "固定字符",
    component: () => import("./str.vue"),
    raw: {
      content: '-'
    }
  },
  {
    id: TYPE_ENUM.field,
    cnName: "表单字段",
    component: () => import("./field.vue"),
    raw: {
      content: ''
    }
  }
];
